import utils from 'utils'

export default class userListCtrl {
    constructor($scope, $uibModal, httpRequest, $state, $stateParams, dictService, sweetalert, initSortService, $rootScope) {
        $scope.userType = $rootScope.userInfo.user.userType
        //获取所有机构列表 非admin获取所有 编辑时需要
        // $scope.userType &&
        //   httpRequest.get_organization(0).then((res) => {
        //     localStorage.setItem('orgList', JSON.stringify(res.data.value));
        //   });
        // 有缓存参数，从缓存中取orgId
        $scope.orgOwnerShip = JSON.parse(localStorage.user_info).user.orgOwnership
        $scope.userTypeOrgId = $scope.userType ? $scope.orgOwnerShip : 0
        $scope.queryParam = {
            pageNum: 1,
            pageSize: 10,
            param: {
                userMobile: '',
                ownerRole: '', // URL带过来的角色名称参数
                isRoleOwner: '1', // 拥有本机构角色
                realName: '', // 姓名
                orgIdList: [], // 所属机构
                status: '',
                ownerDept: '', //部门查询
                createUser: '',
            },
        }
        let searchParams = $stateParams.search
        if (searchParams) {
            searchParams = JSON.parse(decodeURI(searchParams)) // URL带过来的角色名称参数
            $scope.urlSearch = searchParams
            for (var k in searchParams) {
                $scope.queryParam.param[k] = searchParams[k]
            }
        }
        // 表头排序
        if ($scope.userType == 0) {
            $scope.orderMap = initSortService('tenantUserListParam')
        } else {
            $scope.orderMap = initSortService('userListParam')
        }
        $scope.selectedHandle = function () {
            $scope.queryParam.orderMap = {}
            if ($scope.orderMap.sortKey) $scope.queryParam.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
            setStorageParam(JSON.stringify($scope.queryParam))
            $scope.queryOrgInfo()
        }
        $scope.goAddUserPage = function goAddUserPage() {
            $state.go('system.permission.user.add', {
                orgId: $scope.userType == 0 ? $scope.queryParam.param.orgIdList[0] : '',
            })
        }
        $scope.queryOrgInfo = function () {
            if ($scope.userType == 0) {
                $scope.queryParam = sessionStorage.tenantUserListParam ? JSON.parse(sessionStorage.tenantUserListParam) : $scope.queryParam
            } else {
                $scope.queryParam = sessionStorage.userListParam ? JSON.parse(sessionStorage.userListParam) : $scope.queryParam
            }
            httpRequest.post_usersList($scope.queryParam).then((res) => {
                $scope.listData = res.data.value.list
                console.log($scope.listData)
                utils.loaded()
                $scope.queryParam.pageNum = res.data.value.pageNum
                // 获取后台分页数据 回写分页组件
                $scope.totalItems = res.data.value.total //
            })
        }
        $scope.searchList = function () {
            if ($scope.queryParam.param.ownerRoleId) {
                delete $scope.queryParam.param.ownerRoleId
            }
            if ($scope.queryParam.param.ownerDeptId) {
                delete $scope.queryParam.param.ownerDeptId
            }
            setStorageParam(JSON.stringify($scope.queryParam))
            $scope.queryOrgInfo()
        }
        // 分页
        $scope.pageChanged = function () {
            // utils.loading('正在查询···');
            // 点击页码发起查询
            let oldParams = getStorageParam()
            let params = JSON.stringify({
                orderMap: $scope.queryParam.orderMap,
                pageNum: $scope.queryParam.pageNum,
                pageSize: $scope.queryParam.pageSize,
                param: oldParams
                    ? oldParams
                    : {
                          ownerRole: decodeURI($stateParams.roleName), // URL带过来的角色名称参数
                          isRoleOwner: '0', // 拥有本机构角色
                          realName: '', // 姓名
                          orgIdList: [], // 所属机构
                          status: '',
                      },
            })
            setStorageParam(params)
            $scope.queryOrgInfo()
        }
        const code = $scope.userType == 0 ? 'USER_INFO_TUREND' : 'USER_INFO'
        // 导入配置
        $scope.importconfig = {
            code: localStorage.deployType == 2 ? 'BUSINESS_' + code : code,
            isSplitUser: true,
            // 修改原先点击导入可以导入文件，现只能下拉菜单进行导入。导致Excel导入和TXT导入ng-if要多加&& !config.isSplitUser判断 暂时不知会不会影响其他的模块
            isSplit: true,
            validate: {
                pattern: '.xlsx,.xls,.xml',
                _validate: {
                    size: {
                        min: 10,
                        max: '10MB',
                    },
                    duration: {
                        min: '10s',
                        max: '5m',
                    },
                    accept: '.xlsx,.xls,.xml',
                },
            },
            callback() {
                // 回掉，可选
                if ($scope.queryParam.param.ownerRoleId) {
                    delete $scope.queryParam.param.ownerRoleId
                    setStorageParam(JSON.stringify($scope.queryParam))
                }
                if ($scope.queryParam.param.ownerDeptId) {
                    delete $scope.queryParam.param.ownerDeptId
                    setStorageParam(JSON.stringify($scope.queryParam))
                }
                $scope.queryOrgInfo()
            },
        }
        // 点击查询机构信息表
        $scope.showSelected = function showSelected(node, flag) {
            let orgIdList = node.orgId ? [node.orgId] : $scope.userType ? [-2] : []
            $scope.queryParam.param.orgIdList = orgIdList
            $scope.queryParam.pageNum = 1
            if ($scope.queryParam.param.ownerRoleId && !flag) {
                delete $scope.queryParam.param.ownerRoleId
            }
            if ($scope.queryParam.param.ownerDeptId && !flag) {
                delete $scope.queryParam.param.ownerDeptId
            }
            setStorageParam(JSON.stringify($scope.queryParam))
            // 设置选中的表
            $scope.queryOrgInfo()
        }
        $scope.config = {
            check: {
                enable: true, //显示不显示复选框
                chkStyle: 'checkbox',
            },
        }
        $scope.getInfo = function (data) {
            $scope.orgTreeList = data
            // 展开全部节点
            angular.forEach($scope.orgTreeList, function (item, index) {
                item.open = true
                item.checked = false
            })
            $scope.userAllOrgList = $scope.orgTreeList
            // let currentOrgId = $scope.queryParam.param.orgIdList[0];
            // if (currentOrgId) {
            //   for (var i = 0; i < $scope.userAllOrgList.length; i++) {
            //     if ($scope.userAllOrgList[i].orgId == currentOrgId) {
            //       $scope.queryOrgConfig.defaultSelect = [$scope.userAllOrgList[i]];
            //       $scope.queryOrgConfig.parentId =
            //         $scope.userAllOrgList[i].parentOrgId;
            //       break;
            //     }
            //   }
            // }
        }
        let queryFormConfig = [
            {
                label: '手机号',
                selected: true,
                default: true,
            },
            {
                label: '用户姓名',
                selected: true,
                default: true,
            },
            {
                label: '本机构部门',
                selected: false,
                default: false,
            },
            {
                label: '本机构角色',
                selected: false,
                default: false,
            },
            {
                label: '账号状态',
                selected: false,
                default: false,
            },
            {
                label: '创建人',
                selected: false,
                default: false,
            },
            {
                label: '拥有本机构角色',
                selected: true,
                default: true,
            },
        ]
        if ($scope.userType != 0) {
            queryFormConfig.splice(6, 0, {
                label: '所属机构',
                selected: false,
                default: false,
            })
            queryFormConfig.splice(7, 1)
        }
        $scope.customizedConfig = {
            version: 1.09,
            queryConfig: queryFormConfig,
            table: [
                {
                    label: '手机号',
                    selected: true,
                    default: true,
                },
                {
                    label: '用户姓名',
                    selected: true,
                    default: true,
                },
                {
                    label: '本机构部门',
                    selected: true,
                    default: true,
                },
                {
                    label: '本机构角色',
                    selected: true,
                    default: true,
                },
                {
                    label: '邮箱',
                    selected: true,
                    default: true,
                },
                {
                    label: '账号状态',
                    selected: true,
                    default: true,
                },
                {
                    label: '创建人/时间',
                    selected: true,
                    default: true,
                },
            ],
        }
        if (localStorage.deployType == 2) {
            const item = {
                label: '登陆账号',
                selected: true,
                default: true,
            }
            $scope.customizedConfig.table.push(item)
            $scope.customizedConfig.queryConfig.push(item)
        }
        $scope.init = function () {
            // 获取预置密码
            // $scope.userlist.initialPassword
            httpRequest.get_getSysPasswordPolicy().then((res) => {
                $scope.initialPassword = res.data.value.initialPassword
                $scope.czmsg = `重置后用户密码会修改为系统预置密码:${$scope.initialPassword}`
            })
            dictService.get('lock_status')
            // 获取机构列表
            // if ($scope.userType != 0) {
            //   httpRequest.get_organization($scope.userTypeOrgId).then((res) => {
            //     // 展开全部节点
            //     angular.forEach(res.data.value, function (item, index) {
            //       item.open = true;
            //       item.checked = false;
            //     });
            //     $scope.userAllOrgList = res.data.value;
            //     let currentOrgId = $scope.queryParam.param.orgIdList[0];
            //     if (currentOrgId) {
            //       for (var i = 0; i < $scope.userAllOrgList.length; i++) {
            //         if ($scope.userAllOrgList[i].orgId == currentOrgId) {
            //           $scope.queryOrgConfig.defaultSelect = [
            //             $scope.userAllOrgList[i],
            //           ];
            //           $scope.queryOrgConfig.parentId =
            //             $scope.userAllOrgList[i].parentOrgId;
            //           break;
            //         }
            //       }
            //     }
            //     setStorageParam(JSON.stringify($scope.queryParam));
            //     // $scope.queryOrgInfo()
            //   });
            // }
        }
        $scope.init()
        // 机构变化
        $scope.orgSelectChange = function (v) {
            $scope.queryOrgConfig.defaultSelect = v
            if (v && v.length) {
                $scope.queryParam.param.orgIdList = v.map((item) => item.orgId)
            } else {
                $scope.queryParam.param.orgIdList = []
            }
        }
        // 下拉组件配置
        $scope.queryOrgConfig = {
            queryName: 'orgName',
            queryKey: 'orgId',
            queryType: 'statistTree',
            parentIdName: 'parentOrgId',
            multiple: true,
            parentId: 0,
            defaultSelect: [],
        }

        function setDefaultSelect(data) {
            if (!$scope.result) return
            $scope.result.forEach((item) => {
                // 遍历的item
                if (item.sysRoleList && item.sysRoleList.length > 0) {
                    item.sysRoleList.forEach((r) => {
                        r.selected = false
                        if (data.roleList && data.roleList.length) {
                            for (var i = 0; i < data.roleList.length; i++) {
                                if (data.roleList[i].roleId == r.roleId && data.roleList[i].orgId == r.orgId) {
                                    r.selected = true
                                    break
                                }
                            }
                        }
                    })
                }
                if (item.sysUkeyist && item.sysUkeyist.length > 0) {
                    item.sysUkeyist.forEach((k) => {
                        k.selected = false
                        if (data.ukeyList && data.ukeyList.length) {
                            for (var u = 0; u < data.ukeyList.length; u++) {
                                if (data.ukeyList[u].ukeyId == k.ukeyId) {
                                    k.selected = true
                                    break
                                }
                            }
                        }
                    })
                }
            })
        }
        // 表格下拉框
        $scope.tableDropdownConfig = [
            {
                label: '授权',
                handler(item) {
                    utils.loading('正在加载···')
                    $scope.params = {
                        pageSize: 50,
                        pageNum: 1,
                        param: {
                            orgIdByInclude: item.orgOwnership,
                        },
                    }
                    httpRequest.post_getSysOrganizationInfoList(JSON.stringify($scope.params)).then((res) => {
                        $scope.result = res.data.value.list
                        $scope.params = {
                            totalItems: res.data.value.total,
                            pageNum: res.data.value.pageNum,
                            pageSize: res.data.value.pageSize,
                            orgIdByInclude: item.orgOwnership,
                        }
                        utils.loaded()
                        setDefaultSelect(item)
                        const modalInstance = $uibModal.open({
                            templateUrl: 'myModalContent.html',
                            controller: 'userModalInstanceCtrl',
                            backdrop: 'static',
                            openedClass: 'mod-modal mod-modal-lg user-modal-instance',
                            resolve: {
                                items1() {
                                    return item
                                },
                                list() {
                                    return $scope.result
                                },
                                userType() {
                                    return $scope.userType
                                },
                                params() {
                                    return $scope.params
                                },
                            },
                        })
                        modalInstance.result.then(
                            () => {
                                $scope.queryOrgInfo()
                            },
                            () => {}
                        )
                    })
                },
                showWhile(item, hasPermit) {
                    return hasPermit('authority_user')
                },
            },
            {
                label: '编辑',
                handler(item) {
                    sessionStorage.setItem('roleList', JSON.stringify(item.roleList))
                    sessionStorage.setItem('ukeyList', JSON.stringify(item.ukeyList))
                    sessionStorage.setItem('orgOwnership', item.orgOwnership)
                    $state.go('system.permission.user.edit', {
                        userId: item.userId,
                    })
                },
                showWhile(item, hasPermit) {
                    return hasPermit('edit_user') && ($scope.userType == 0 || item.permissionsStatus)
                },
            },
            {
                label: '重置密码',
                handler(item) {
                    sweetalert.confirm('密码重置', $scope.czmsg).then(() => {
                        httpRequest.resetPassword(item.userName, '密码重置成功')
                    })
                },
                showWhile(item, hasPermit) {
                    return hasPermit('reset_password_user') && ($scope.userType == 0 || item.permissionsStatus)
                },
            },
            {
                label: '删除',
                handler(item) {
                    sweetalert.confirm('删除确认', '确认删除该用户吗?').then(() => {
                        httpRequest.remove_userInfo(item.userId, '删除用户成功').then((res) => {
                            $scope.queryOrgInfo()
                        })
                    })
                },
                showWhile(item, hasPermit) {
                    return hasPermit('del_user') && ($scope.userType == 0 || item.permissionsStatus)
                },
            },
            {
                label: '变更所属机构',
                handler(item) {
                    const modalInstance = $uibModal.open({
                        templateUrl: 'changeOrg.html',
                        controller: [
                            '$scope',
                            '$uibModalInstance',
                            'items1',
                            'logger',
                            'httpRequest',
                            'userTypeOrgId',
                            function ($scope, $uibModalInstance, items1, logger, httpRequest, userTypeOrgId) {
                                $scope.changeOrgData = items1
                                $scope.items1 = items1
                                $scope.userTypeOrgId = userTypeOrgId
                                console.log(items1)
                                //获取部门
                                const getDepartmentList = function getDepartmentList(orgId, val) {
                                    // if (!$scope.adduserInfo.orgOwnership && $scope.userType == 0) return
                                    let params = {
                                        pageNum: 0,
                                        pageSize: 10000,
                                        param: {
                                            orgId: orgId,
                                        },
                                    }
                                    // if ($scope.adduserInfo.orgOwnership && $scope.userType == 0) {
                                    //     params.param.orgId = $scope.adduserInfo.orgOwnership
                                    // }
                                    httpRequest.post_qryDepartmentList(params).then((res) => {
                                        $scope.departmentList = []
                                        $scope.departmentList = res.data.value.list
                                        // console.log($scope.departmentList)
                                        if (val == 'check') {
                                            $scope.changeOrgData.departmentId = $scope.departmentList[0].departmentId
                                        }
                                        // for (const item of $scope.departmentList) {
                                        //     if(item.departmentId == $scope.changeOrgData.departmentId){
                                        //         console.log(111)
                                        //         $scope.changeOrgData.departmentId = item.departmentId
                                        //         return
                                        //     }else{
                                        //         console.log(222)
                                        //         $scope.changeOrgData.departmentId = $scope.departmentList[0].departmentId
                                        //     }

                                        // }
                                    })
                                }
                                getDepartmentList($scope.items1.orgOwnership)

                                //优化 获取角色
                                const getOrgRoleList = function getOrgRoleList(orgId) {
                                    httpRequest.get_getSysOrgById(orgId, false).then((res) => {
                                        // console.log(res)
                                        $scope.sysRoleList = res.data.value.sysRoleList
                                        if ($scope.sysRoleList.length > 0) {
                                            for (const b of $scope.sysRoleList) {
                                                for (const List of $scope.items1.roleList) {
                                                    if (b.roleId == List.roleId && b.orgId == List.orgId) {
                                                        b.selected = true
                                                    }
                                                }
                                            }
                                        } else {
                                            $scope.sysRoleList = []
                                            logger.logError('该用户所属机构下无角色')
                                        }
                                    })
                                }
                                getOrgRoleList($scope.items1.orgOwnership)
                                // const getRoleList = function getRoleList(orgId) {
                                //   httpRequest
                                //     .post_getNotPageSysOrganizationInfoList(items1.orgOwnership)
                                //     .then((res) => {
                                //       // console.log(res.data.value)
                                //       $scope.sysRoleList = []
                                //       for (const item of res.data.value) {
                                //         if (item.orgId == orgId) {
                                //           $scope.sysRoleList = item.sysRoleList
                                //         }
                                //       }
                                //       if ($scope.sysRoleList.length > 0) {
                                //         for (const b of $scope.sysRoleList) {
                                //           for (const List of $scope.items1.roleList) {
                                //             if (
                                //               b.roleId == List.roleId &&
                                //               b.orgId == List.orgId
                                //             ) {
                                //               b.selected = true
                                //             }
                                //           }
                                //         }
                                //       } else {
                                //         $scope.sysRoleList = []
                                //         logger.logError('该用户所属机构下无角色')
                                //       }
                                //     })
                                // }
                                // getRoleList($scope.items1.orgOwnership)

                                //获取开票点
                                const queryOrgInfo = function (orgId) {
                                    httpRequest.get_qryAssignUkeyList(orgId).then((res) => {
                                        $scope.allUkeyIdList = []
                                        $scope.allUkeyIdList = res.data.value
                                        for (const a in $scope.allUkeyIdList) {
                                            if ($scope.isManager) {
                                                $scope.allUkeyIdList[a].selected = true
                                            } else {
                                                $scope.allUkeyIdList[a].selected = false
                                            }
                                        }
                                        // 修改状态
                                        for (let i = 0; i < $scope.items1.ukeyList.length; i++) {
                                            for (const b in $scope.allUkeyIdList) {
                                                if ($scope.allUkeyIdList[b].ukeyId == $scope.items1.ukeyList[i].ukeyId) {
                                                    $scope.allUkeyIdList[b].selected = true
                                                }
                                            }
                                        }
                                    })
                                }
                                queryOrgInfo($scope.items1.orgOwnership)

                                $scope.isManager = false
                                // const get_userInfo = function () {
                                //     httpRequest.get_userInfo(items1.userId).then((res) => {
                                //         $scope.from = res.data.value
                                //         if($scope.from.userName = $scope.from.userMobile) $scope.usePhone = '1'
                                //         getDepartmentList(res.data.value.orgOwnership)
                                //         getRoleList(res.data.value.orgOwnership)
                                //         $scope.from.roleList.forEach(item => {
                                //             if (item.roleType == 2) $scope.isManager = true
                                //         })
                                //         queryOrgInfo()
                                //     })
                                // }
                                // get_userInfo()
                                // $scope.roleChange = (i) => {
                                //     $scope.isManager = false
                                //     console.log(i)
                                //     // $scope.changeOrgData.roleList.forEach(item => {
                                //     //     i.split(',').forEach(id => {
                                //     //         if (item.roleId == id && item.roleType == 2) $scope.isManager = true
                                //     //     })
                                //     // })
                                // }
                                $scope.$watch('isManager', () => {
                                    if ($scope.isManager) {
                                        for (const a in $scope.allUkeyIdList) {
                                            $scope.allUkeyIdList[a].selected = true
                                        }
                                    }
                                })

                                //获取机构列表
                                httpRequest.get_organization($scope.userTypeOrgId).then((res) => {
                                    console.log('请求')
                                    $scope.orgList = res.data.value
                                })

                                /**
                        24 * arr: 对象数组
                        25 * filter: 过滤字段
                        26 * keyWord: 输入的字符
                        27 */
                                function queryArrByType(arr, filter, keyWord) {
                                    if (!(filter instanceof Array) && !typeof filter) throw new TypeError('filter must be a array or string')
                                    if (typeof filter === 'string') filter = [filter]
                                    return arr.filter((item) => {
                                        for (var key of filter) {
                                            if (item[key] && item[key].indexOf(keyWord) !== -1) {
                                                return true
                                            }
                                        }
                                        return false
                                    })
                                }
                                $scope.searchVal = items1.orgOwnershipName
                                $scope.setFocusDef = function (searchVal) {
                                    if (searchVal == '') $scope.showSearchorglist = $scope.orgList
                                    // if(searchVal == ''){
                                    //     $scope.searchVal = items1.orgOwnershipName
                                    // }
                                }
                                $scope.setBlurDef = function (searchVal) {
                                    // if(searchVal == '') $scope.showSearchorglist = $scope.orgList
                                    if (searchVal == '') {
                                        $scope.searchVal = items1.orgOwnershipName
                                    }
                                }
                                $scope.chooseItem = false
                                $scope.searchOrg = function (searchVal) {
                                    console.log(searchVal)
                                    if (searchVal != '') {
                                        $scope.showSearchorglist = []
                                        $scope.showSearchorglist = queryArrByType($scope.orgList, ['orgName'], searchVal)
                                        for (const item of $scope.showSearchorglist) {
                                            item.choosed = false
                                        }
                                        $scope.chooseItem = true
                                        console.log($scope.showSearchorglist)
                                    }
                                }

                                $scope.checkItem = function (item) {
                                    console.log(item)
                                    let selectedList = []
                                    selectedList.push(item)
                                    $scope.changeOrgData.orgOwnership = item.orgId
                                    $scope.changeOrgData.orgOwnershipName = item.orgName
                                    $scope.searchVal = item.orgName

                                    getDepartmentList(item.orgId, 'check')
                                    // getRoleList(item.orgId)
                                    getOrgRoleList(item.orgId)
                                    queryOrgInfo(item.orgId)
                                    // scope.chooseSearchValChange()
                                    // setTreeSelected(scope.selectorglist, scope.selectedList)
                                    // scope.orgChange && scope.orgChange(scope.selectedList,item)
                                    $scope.chooseItem = false
                                }

                                $scope.cancel = function cancel() {
                                    $uibModalInstance.dismiss()
                                }
                                $scope.ok = function ok() {
                                    let ukeyIdList = []
                                    let roleList = []
                                    for (let i = 0; i < $scope.allUkeyIdList.length; i++) {
                                        if ($scope.allUkeyIdList[i].selected == true) {
                                            ukeyIdList.push($scope.allUkeyIdList[i].ukeyId)
                                        }
                                    }
                                    for (let i = 0; i < $scope.sysRoleList.length; i++) {
                                        if ($scope.sysRoleList[i].selected == true) {
                                            roleList.push({
                                                orgId: $scope.sysRoleList[i].orgId,
                                                roleId: $scope.sysRoleList[i].roleId,
                                            })
                                        }
                                    }
                                    console.log(roleList)
                                    for (const a in $scope.s3item) {
                                        $scope.from.roleList.push({
                                            orgId: $scope.s3item[a].orgId,
                                            roleId: $scope.s3item[a].id,
                                        })
                                    }
                                    $scope.changeOrgData.ukeyIdList = ukeyIdList
                                    $scope.changeOrgData.roleList = roleList
                                    console.log($scope.changeOrgData)
                                    $scope.changeOrgData.usedPasswordDefault = Number($scope.changeOrgData.usedPasswordDefault)
                                    if ($scope.chooseItem) return logger.logError('请选择机构')
                                    if ($scope.searchVal == '') return logger.logError('请选择机构')
                                    if ($scope.changeOrgData.departmentId == '') return logger.logError('请选择部门')
                                    const isArr = Boolean($scope.changeOrgData.roleList.length)

                                    if (!isArr) {
                                        logger.logError('请选择角色')
                                        $scope.changeOrgData.usedPasswordDefault = Boolean($scope.changeOrgData.usedPasswordDefault)
                                    } else if (isArr) {
                                        httpRequest.updata_userInfo($scope.changeOrgData, '用户信息保存成功').then((res) => {
                                            $uibModalInstance.close()
                                        })
                                    } else {
                                    }
                                }
                            },
                        ],
                        backdrop: 'static',
                        openedClass: 'mod-modal mod-modal-lg user-modal-instance',
                        resolve: {
                            items1() {
                                console.log(item)
                                return item
                            },
                            userTypeOrgId() {
                                return $scope.userTypeOrgId
                            },
                        },
                    })
                    modalInstance.result.then(
                        () => {
                            $scope.queryOrgInfo()
                        },
                        () => {}
                    )
                },
                showWhile(item, hasPermit) {
                    return hasPermit('role_change_permissions') && ($scope.userType == 0 || item.permissionsStatus)
                },
            },
        ]

        function buildTree(list, rootId) {
            // 适配树组件数据结构
            function recursion(data, pid) {
                const result = []
                let temp
                for (const i in data) {
                    if (data[i].parentOrgId == pid) {
                        result.push(data[i])
                        temp = recursion(data, data[i].orgId)
                        if (temp.length > 0) {
                            data[i].children = temp
                        }
                    }
                }
                return result
            }
            return recursion(list, rootId)
        }
        $scope.reset = function () {
            let orgIdList = []
            if ($scope.userType == 0) {
                orgIdList = $scope.queryParam.param.orgIdList
            }
            $scope.queryParam = {
                pageNum: 1,
                pageSize: 10,
                param: {
                    userMobile: '',
                    ownerRole: '', // URL带过来的角色名称参数
                    isRoleOwner: '1', // 拥有本机构角色
                    realName: '', // 姓名
                    orgIdList: orgIdList, // 所属机构
                    status: '',
                    ownerDept: '', //部门查询
                    createUser: '',
                },
            }
            $scope.queryOrgConfig.defaultSelect = []
            $scope.$broadcast('selectedOrgList', [])
        }

        function getStorageParam() {
            if ($scope.userType == 0) {
                if (sessionStorage.tenantUserListParam) return JSON.parse(sessionStorage.tenantUserListParam).param
                return ''
            } else {
                if (sessionStorage.userListParam) return JSON.parse(sessionStorage.userListParam).param
                return ''
            }
        }

        function setStorageParam(params) {
            if ($scope.userType == 0) {
                sessionStorage.setItem('tenantUserListParam', params)
            } else {
                sessionStorage.setItem('userListParam', params)
            }
        }
        // 树组件参数
        $scope.treeOptions = {
            nodeChildren: 'children',
            dirSelectable: true,
            allowDeselect: false,
            injectClasses: {
                ul: 'a1',
                li: 'a2',
                liSelected: 'a7',
                iExpanded: 'a3',
                iCollapsed: 'a4',
                iLeaf: 'a5',
                label: 'a6',
                labelSelected: 'a8',
            },
        }
        $scope.exportExel = function exportExel() {
            let _url = `${host.etcloud}auth/sysUser/exportDrawerOrgToExcel?accessToken=${localStorage.getItem('id_token')}`
            utils.file_download(
                _url,
                {},
                '', //type
                'POST',
                'blob',
                '',
                false
            )
            // utils.post_downLoad({}, _url)
        }
    }
}
userListCtrl.$inject = ['$scope', '$uibModal', 'httpRequest', '$state', '$stateParams', 'dictService', 'sweetalert', 'initSortService', '$rootScope']



// WEBPACK FOOTER //
// ./src/app/system/permission/user/userListCtrl.js